const layout = {
  font: {
    family: "Libre Franklin,sans-serif",
  },

  title: {
    text: "Timeline - Maßnahmen",
    font: {
      family: 'Georgia',
      size: 20,
      color: '#000',
      weight: 'bold',
    },
    x: "0.5",
    y: "auto",

    xref: "container",
    yref: "container",
  },

  showlegend: false,

  // width: 1000,
  height: '300px',

  xaxis: {
    type: "date",
    showgrid: false,
    range: {
      0: "2008-10-20 19:56:11.0009",
      1: "2009-07-11 04:03:48.9991",
    },
    autorange: true,
    visible: true,
    calendar: "gregorian",
    color: "#444",
    tickmode: "auto",
    nticks: 0,
    showticklabels: true,
    tickangle: "auto",
    showline: false,
    gridwidth: 0,
    automargin: false,
    showspikes: false,
    anchor: "y",
    side: "bottom",
    domain: {
      0: 0,
      1: 1,
    },
    layer: "above traces",
    fixedrange: false,
    constrain: "range",
    constraintoward: "center",
  },

  yaxis: {
    showticklabels: true,
    showgrid: false,
    zeroline: false,
    color: "#444",
    showline: false,
    anchor: "x",
    side: "left",
    tickvals: [],
    ticktext: [],
    tickfont: {
      size: 15,
    },
  },

  shapes: [{}],

  hovermode: "closest",

  margin: {
    b: 30,
    l: 110,
    r: 0,
    t: 60,
    pad: 15,
    autoexpand: true,
  },

  separators: ".,",

  annotations: [{}],
}

export default layout
